import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";
import { useState } from "react";

const LIMIT = 1600;

interface MessageInputProps {
  onSend: (message: string) => Promise<void> | null;
  disabled: boolean | false;
}

const MessageInput: React.FC<MessageInputProps> = ({ onSend, disabled }) => {
  const [message, setMessage] = useState<string>("");

  const handleSend = () => {
    if (onSend) onSend(message || ""); //pass message to callback
    setMessage(""); //clear message
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value.substring(0, LIMIT));
  };

  return (
    <div className="flex flex-col p-1 items-end gap-2 border rounded-lg bg-muted">
      <Textarea
        placeholder="Respond as Field Agent"
        onChange={handleChange}
        value={message}
        className="bg-background h-32"
        disabled={disabled}
      />
      <div className="text-sm text-muted-foreground text-left w-full pl-2">
        {message.length} / {LIMIT} character limit
      </div>
      <Button
        variant="ghost"
        onClick={handleSend}
        disabled={disabled || message.trim() === ""}
      >
        Send
        <Send />
      </Button>
    </div>
  );
};

export default MessageInput;
